<template>
  <div id="app">
    <!--<p>新得分H5相关模块</p>-->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
 html,body,#app{
   width: 100%;
   max-width: 768px;
   margin: 0 auto;
   height: 100%;
   box-sizing: border-box;
   -webkit-overflow-scrolling:touch;
 }
html{
}
body{
  padding:0;
  margin:0;
  overflow: auto;
}

#app {
  font-family: PingFangSC-Regular;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
}
p {
  margin: 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
.van-search{
  background:#F6F7FB !important;
}

.van-cell {
  text-align: left;
}
.van-hairline--top-bottom:after{
  border:none;
}

a {
  color: #42b983;
}

.van-cell:not(:last-child)::after {
  right: 15px;
}
.van-tabs__line{
  background-color:#608BF7;
  height:0.02rem;
}

</style>



// WEBPACK FOOTER //
// src/App.vue